import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import AuthorizeState from '@context/AuthorizeState'
import AlertsState from '@context/AlertsState'
import Head from 'next/head'
import { YMInitializer } from 'react-yandex-metrika'
import { useRouterSubscriber } from 'src/infastruct/effector-utils/use-router-subscriber'
import { useOnMountMain, useOnUnmountMain } from 'src/processes/core/hooks'
import dynamic from 'next/dynamic'
import { $device, Device } from 'src/processes/core/device'
import { useUnit } from 'effector-react'

LayoutBaseHoc.propTypes = {
    children: PropTypes.element.isRequired,
    mobile: PropTypes.string
}

const MobileLayout = dynamic(() => import('@components/Layout/MobileLayout'))
const Base = dynamic(() => import('@components/Layout/Base'))
const isProduction = process.env.NEXT_PUBLIC_NODE_ENV === 'production'
function LayoutBaseHoc({ children }) {
    const onMountMain = useOnMountMain()
    const onUnmountMain = useOnUnmountMain()
    const device = useUnit($device)
    const isMobile = device === Device.Mobile
    useEffect(() => {
        onMountMain()
        return () => {
            onUnmountMain()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useRouterSubscriber()

    return (
        <React.Fragment>
            <Head>
                <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="language" content="ru" />
                <title>Интернет-аптека, заказ и доставка лекарств в сети аптек ЗДОРОВ.ру</title>
                <link rel="icon" type="image/png" href="/favicon.ico" />
                <meta name="apple-mobile-web-app-title" content="Zdorov.ru" />
                <meta name="application-name" content="Zdorov.ru" />
                <meta name="theme-color" content="#ffffff" />
                <meta name="apple-itunes-app" content="app-id=1252077901" />
                <meta name="yandex-verification" content="62458a841a05f28f" />
            </Head>
            {isProduction && (
                <YMInitializer
                    accounts={[26662365]}
                    options={{
                        defer: true,
                        clickmap: true,
                        trackLinks: true,
                        accurateTrackBounce: true,
                        webvisor: true
                    }}
                    version="2"
                />
            )}
            <AuthorizeState>
                <AlertsState>
                    {isMobile ? <MobileLayout>{children}</MobileLayout> : <Base>{children}</Base>}
                </AlertsState>
            </AuthorizeState>
        </React.Fragment>
    )
}

export default LayoutBaseHoc
